import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let IconClose = (props) => {
  props = Object.assign({viewBox: '6 6 24 24'}, props);
  return (
    <SvgIcon {...props}>
      <path d="M18,30c-6.6,0-12-5.4-12-12S11.4,6,18,6c6.6,0,12,5.4,12,12S24.6,30,18,30z M22,13l-4,4.1L14,13l-1,1l4,4.1
	L13.2,22l1,1l3.8-3.9l3.8,3.9l1-1L19,18.1l4-4.1L22,13z"/>
    </SvgIcon>
  );
};

IconClose.displayName = 'IconClose';
IconClose.muiName = 'SvgIcon';

export default IconClose;



// WEBPACK FOOTER //
// ./src/components/Icons/IconClose.js